module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "test"
    }
  }, [_c('h2', [_vm._v("Data Store")]), _vm._v(" "), _c('div', {
    staticClass: "report-content"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_vm._v("The following represents the current client object, and is used for basic testing during development.")]), _vm._v(" "), _c('pre', [_vm._v("      " + _vm._s(_vm.getValue) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-460da2ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Developer/Developer.vue
// module id = 317
// module chunks = 0